document.addEventListener('DOMContentLoaded', function() {
    App.vue.init();

    window.goTo = function goTo(vueComponentName) {

        var destination = document.querySelector('[data-vue="'+vueComponentName+'"]');
        if(destination) {
            destination.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
        }

    }
    if(window.location.hash) {
        let hash = window.location.hash.replace('#','');
        setTimeout(()=>{ window.goTo(hash);},600)

    }
    window.inDev = ()=>{
        window.showNotification("warning","Coming soon","Данная функция находится в разработке.");
    };
    window.addEventListener('hashchange', () => {
        let hash = window.location.hash.replace('#','');
        setTimeout(()=>{ window.goTo(hash);},10)
    }, false);
    //javascript:goTo('TasksSection')
})